<template>
	<div id="app">
		<MediaSelector />
		<router-view />
	</div>
</template>

<script>
import MediaSelector from 'bh-mod/components/file/MediaSelector'

export default {
	name: 'app',
	components: { MediaSelector },
	watch: {
		'$route'(to, from) {
			const query = Object.assign({}, to.query)
			this.$store.commit('SETUP_URL_SETTINGS', query)
		},
	},
}
</script>
<style>
#app {
	min-height: 100vh;
}
</style>
